/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Metrics.EvaluationType_
///   This is an auto-generated enumeration of the SWFC_Learning.Metrics.EvaluationType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum EvaluationType_ {
   /// <summary>
   ///   Practice (Practice)
   /// </summary>
   Practice = 1,
   /// <summary>
   ///   Assessment (Assess)
   /// </summary>
   Assessment = 2,
   /// <summary>
   ///   Preview Question (Preview)
   /// </summary>
   PreviewQuestion = 3
}

export const EvaluationTypes: EvaluationType[] = [
   {
      code: EvaluationType_.Practice,
      literal: 'Practice',
      description: 'Practice',
      shortDescription: 'Practice',
      listPriority: 1,

      typeName: "EvaluationType"
   },
   {
      code: EvaluationType_.Assessment,
      literal: 'Assessment',
      description: 'Assessment',
      shortDescription: 'Assess',
      listPriority: 2,

      typeName: "EvaluationType"
   },
   {
      code: EvaluationType_.PreviewQuestion,
      literal: 'PreviewQuestion',
      description: 'Preview Question',
      shortDescription: 'Preview',
      listPriority: 3,

      typeName: "EvaluationType"
   }
]

export class EvaluationType implements IDomainModel {
   code: EvaluationType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: EvaluationType_): EvaluationType {
      return EvaluationTypes.find(d => d.code === code)
   }
}
